import { render, staticRenderFns } from "./BookFavoriteButton.vue?vue&type=template&id=e5830966&"
import script from "./BookFavoriteButton.vue?vue&type=script&lang=js&"
export * from "./BookFavoriteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports